import type { PrimitiveAtom } from "jotai";
import { useAtom } from "jotai";

export function usePopup(openAtom: PrimitiveAtom<boolean>) {
  const [isOpen, setIsOpen] = useAtom(openAtom);

  function closePopup() {
    setIsOpen(false);
  }

  function openPopup() {
    setIsOpen(true);
    setTimeout(() => {
      closePopup();
    }, 5000);
  }

  return {
    models: {
      isOpen,
    },
    operations: {
      openPopup,
      closePopup,
    },
  };
}
